import {PageLink, PageTitle} from '../../_metronic/layout/core'
import {ListWrapper} from './list/ListWrapper'

const franchiseBreadcrumbs: Array<PageLink> = [
  {
    title: 'Admin',
    path: '/admin/franchises',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const FranchisePage = () => {
  return (
    <>
      <PageTitle breadcrumbs={franchiseBreadcrumbs}>Lista de Franquias</PageTitle>
      <ListWrapper />
    </>
  )
}

export default FranchisePage
